// Alte Adressen → neue Seite. Einfach eine Zeile ergänzen.
export const REDIRECTS = {
  "/mitglied-werden": "/preise",
  "/team": "/ueber-uns",
  "/kontakt": "/#kontakt",
  "/kursplan-1": "/kursplan",
};
